import React from 'react';
import { ShieldCheck, Clock, Leaf } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { CustomerReview } from '../components/CustomerReview';
import { BenefitSection } from '../components/BenefitSection';
import { TestimonialCard } from '../components/TestimonialCard';
import { StarRating } from '../components/ui/StarRating';
export function LulutoxLanding() {
  // Calculate yesterday's date
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const formattedDate = yesterday.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-32">
      <div className="max-w-6xl mx-auto px-4 pb-8 md:pb-12" data-id="element-33">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-34">
          {/* Left Column - Advertorial Banner + Main Content */}
          <div className="lg:col-span-8" data-id="element-35">
            {/* Top Banner */}
            <div className="text-[10px] text-center py-1 text-gray-500 uppercase tracking-widest mb-2 md:mb-2" data-id="element-36">
              Advertorial
            </div>

            {/* Main Content */}
            <main data-id="element-37">
              {/* Hero Section */}
              <header className="mb-8" data-id="element-38">
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-39">
                  5 Reasons Why TikTok Famous Lulutox Detox Tea Is Top 1 Choice
                  For Weight Loss
                </h1>

                <div className="flex items-center gap-3 border-b border-gray-200 pb-6" data-id="element-40">
                  <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&h=100&q=80" alt="Andrea Stewart" className="w-10 h-10 rounded-full object-cover" data-id="element-41" />
                  <div data-id="element-42">
                    <div className="text-sm font-bold text-[#10b981]" data-id="element-43">
                      Andrea Stewart
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-44">{formattedDate}</div>
                  </div>
                </div>
              </header>

              {/* Before/After Hero Image */}
              <div className="mb-8 relative" data-id="element-45">
                <img src="https://cdn.magicpatterns.com/uploads/fBN4r48GWwg3gZRvj9QU9y/1.jpg" alt="Before and after transformation with Lulutox tea" className="w-full rounded-lg shadow-lg" data-id="element-46" />
              </div>

              {/* Intro Text */}
              <div className="bg-pink-50 border-l-4 border-pink-500 p-4 mb-4" data-id="element-47">
                <p className="font-medium text-gray-800 md:text-[21px]" data-id="element-48">
                  <span className="font-bold" data-id="element-49">
                    We all know the frustration of fatigue and low energy
                  </span>
                  , failing to lose stubborn fat, and feeling bloated for
                  seemingly no reason.
                </p>
              </div>

              {/* As Seen In Section */}
              <div className="mb-4 text-center" data-id="element-50">
                <h3 className="text-default font-bold text-gray-500 uppercase tracking-widest mb-4" data-id="element-51">
                  AS SEEN IN
                </h3>
                <img src="https://cdn.magicpatterns.com/uploads/bmcYkD4nJPBiAuyyMnQbNA/featured.png" alt="Featured in major publications" className="w-full max-w-2xl mx-auto" data-id="element-52" />
              </div>

              <p className="text-lg md:text-[21px] text-gray-700 mb-10 leading-relaxed" data-id="element-53">
                Thousands of people are turning to Lulutox to help address these
                and other problems with great success.{' '}
                <span className="font-bold" data-id="element-54">
                  Here are 5 reasons why people swear by Lulutox... And why you
                  NEED to try it too.
                </span>
              </p>

              {/* Benefit 1 */}
              <BenefitSection number={1} title="Lose Hormonal Weight Around The Waist And Hips" description={<>
                    <p className="mb-4 md:text-[21px]" data-id="element-56">
                      The active ingredients in Lulutox are perfect for helping supercharge your metabolism,
                      aiding and{' '}
                      <span className="font-bold" data-id="element-57">
                        speeding up weight loss as a result.
                      </span>{' '}
                      Not only can it shed naturally, but speed up your efforts
                      too!{' '}
                      <span className="font-bold" data-id="element-58">
                        87% of women feel results on the first days of using.
                      </span>
                    </p>
                  </>} imageSrc="https://cdn.magicpatterns.com/uploads/6BttqaZS2e41iGhegfu95R/3.jpg" imageAlt="Graph showing weight loss progress" reverse={true} data-id="element-55" />

              {/* Benefit 2 */}
              <BenefitSection number={2} title="Bloating Is Gone – Even After Eating" description={<p className="md:text-[21px]" data-id="element-60">
                    No one enjoys feeling and looking bloated. Get rid of that
                    dreaded belly bulge with a simple, pleasant daily ritual,
                    aid gut health, and{' '}
                    <span className="font-bold" data-id="element-61">feel lighter fast</span>. In
                    fact,{' '}
                    <span className="font-bold" data-id="element-62">
                      over 98% of Lulutox users reported noticeably flatter
                      bellies and greatly reduced bloating.
                    </span>
                  </p>} imageSrc="https://cdn.magicpatterns.com/uploads/3MDm6TcPy9ECNyFU6ik6qz/4.jpg" imageAlt="Before and after weight loss transformation" data-id="element-59" />

              {/* Benefit 3 */}
              <BenefitSection number={3} title="Start Feeling Energized" description={<p className="md:text-[21px]" data-id="element-64">
                    Coffee is a double-edged sword... Instead, with a cup of
                    Lulutox, you can{' '}
                    <span className="font-bold" data-id="element-65">
                      enjoy the same energy boost without the dreaded caffeine
                    </span>{' '}
                    or sugar crash that comes with alternatives. Face the day
                    with new-found energy!
                  </p>} imageSrc="https://cdn.magicpatterns.com/uploads/8h8iVdAB6mhbaXK7FhzJSL/5.jpg" imageAlt="Woman enjoying Lulutox detox tea" imageLeft={true} data-id="element-63" />

              {/* Benefit 4 */}
              <BenefitSection number={4} title="Clean Your Body Of Toxins" description={<p className="md:text-[21px]" data-id="element-67">
                    The world is a dirty place. We ingest, breathe in, and make
                    contact with all sorts of toxins and chemicals.{' '}
                    <span className="font-bold" data-id="element-68">
                      The natural herbs in Lulutox
                    </span>{' '}
                    will aid your body's detoxification process,{' '}
                    <span className="font-bold" data-id="element-69">
                      lightens the body through toxin disposal
                    </span>
                    , and helps live a cleaner, healthier life.
                  </p>} imageSrc="https://cdn.magicpatterns.com/uploads/ixsmHkbLscvn7PDxqP8HJM/6.jpg" imageAlt="Fresh tea leaves in hand" data-id="element-66" />

              {/* Benefit 5 */}
              <BenefitSection number={5} title="Improves Immune System Function" description={<p className="md:text-[21px]" data-id="element-71">
                    Germs are just as plentiful as toxins. A cup of Lulutox a
                    day will help{' '}
                    <span className="font-bold" data-id="element-72">
                      boost your immune system, wellness, and resilience.
                    </span>
                  </p>} imageSrc="https://cdn.magicpatterns.com/uploads/4DboK8zsZ8bhfGv7Rxdh7m/7.jpg" imageAlt="Lulutox tea in glass cup" imageLeft={true} data-id="element-70" />

              {/* Mid-page CTA Box */}
              <div className="bg-pink-50 border border-pink-200 rounded-xl p-6 md:p-8 my-6 text-center shadow-sm" data-id="element-73">
                <h3 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-74">
                  Don't Miss The Best Chance To Try Lulutox
                </h3>
                <p className="text-gray-700 mb-6 mx-auto text-xl md:text-[21px] leading-8" data-id="element-75">
                  You can take advantage of a massive{' '}
                  <span className="font-bold text-pink-600" data-id="element-76">70% OFF SALE</span>{' '}
                  that's happening <span className="font-bold" data-id="element-77">RIGHT NOW</span>.
                  As of time of writing, you can{' '}
                  <a href="https://trk.healthproductsguru.com/click" className="text-blue-600 underline font-medium" data-id="element-78">
                    try Lulutox at an incredible price
                  </a>{' '}
                  and significantly{' '}
                  <span className="font-bold" data-id="element-79">boost your wellness</span>.
                </p>
                <div className="flex justify-center mb-4" data-id="element-80">
                  <CTAButton size="lg" data-id="element-81">CHECK AVAILABILITY</CTAButton>
                </div>
                <p className="text-pink-600 font-bold text-lg md:text-[21px] uppercase tracking-wide animate-pulse" data-id="element-82">
                  Flash Sale: 70% Off - Limited Time
                </p>
              </div>

              {/* Ingredients Section */}
              <div className=" rounded-xl p-6 md:p-8 mb-4" data-id="element-83">
                <h3 className="text-2xl font-bold text-[#10b981] mb-6" data-id="element-84">
                  The Secret Behind Lulutox Detox Tea's Effectiveness
                </h3>
                <p className="mb-6 text-gray-700 md:text-[21px]" data-id="element-85">
                  There's no magic here.{' '}
                  <span className="font-bold" data-id="element-86">
                    Lulutox contains a massive 13 superfoods
                  </span>{' '}
                  you won't find in a more{' '}
                  <span className="font-bold" data-id="element-87">
                    affordable, delicious, and easily-accessible form.
                  </span>
                </p>

                <ul className="space-y-4 mb-8" data-id="element-88">
                  <li className="flex gap-3 items-start text-sm md:text-[21px] text-gray-700 leading-relaxed" data-id="element-89">
                    <div className="flex-shrink-0 flex items-center h-[1.5em]" data-id="element-90">
                      <img src="https://cdn.magicpatterns.com/uploads/e9fYvkuAfJky6DTroBeWi8/check.svg" alt="Check" className="w-[24px] h-[24px]" data-id="element-91" />
                    </div>
                    <span data-id="element-92">
                      <span className="font-bold" data-id="element-93">
                        Matcha Green Tea, Yerba Mate, and Oolong Tea:
                      </span>{' '}
                      for weight loss, reduced bloating, and improved digestion.
                      These ingredients have been shown to be effective in
                      supporting a healthy gut.
                    </span>
                  </li>
                  <li className="flex gap-3 items-start text-sm md:text-[21px] text-gray-700 leading-relaxed" data-id="element-94">
                    <div className="flex-shrink-0 flex items-center h-[1.5em]" data-id="element-95">
                      <img src="https://cdn.magicpatterns.com/uploads/e9fYvkuAfJky6DTroBeWi8/check.svg" alt="Check" className="w-[24px] h-[24px]" data-id="element-96" />
                    </div>
                    <span data-id="element-97">
                      <span className="font-bold" data-id="element-98">
                        Dandelion Leaf, Ginseng, Milk Thistle, Nettle Leaf,
                        Lemongrass, Goji Berries, Citric Acid:
                      </span>{' '}
                      for heart health. These ingredients have a long-standing
                      history of beneficial qualities that support a healthy
                      heart.
                    </span>
                  </li>
                  <li className="flex gap-3 items-start text-sm md:text-[21px] text-gray-700 leading-relaxed" data-id="element-99">
                    <div className="flex-shrink-0 flex items-center h-[1.5em]" data-id="element-100">
                      <img src="https://cdn.magicpatterns.com/uploads/e9fYvkuAfJky6DTroBeWi8/check.svg" alt="Check" className="w-[24px] h-[24px]" data-id="element-101" />
                    </div>
                    <span data-id="element-102">
                      <span className="font-bold" data-id="element-103">
                        Sencha Green Tea and Ginseng:
                      </span>{' '}
                      for energy, alertness, and improved focus. These
                      ingredients have been shown to help increase mental
                      clarity and boost energy levels.
                    </span>
                  </li>
                  <li className="flex gap-3 items-start text-sm md:text-[21px] text-gray-700 leading-relaxed" data-id="element-104">
                    <div className="flex-shrink-0 flex items-center h-[1.5em]" data-id="element-105">
                      <img src="https://cdn.magicpatterns.com/uploads/e9fYvkuAfJky6DTroBeWi8/check.svg" alt="Check" className="w-[24px] h-[24px]" data-id="element-106" />
                    </div>
                    <span data-id="element-107">
                      Other ingredients{' '}
                      <span className="font-bold" data-id="element-108">
                        rich in antioxidants and anti-inflammatory properties
                      </span>
                      , ensuring that you're getting the most out of your health
                      routine.
                    </span>
                  </li>
                </ul>

                <div className="flex flex-col md:flex-row gap-6 items-center bg-white rounded-lg border border-gray-100" data-id="element-109">
                  <img src="https://magicpatterns-assets.s3.us-west-1.amazonaws.com/static/misc/tea.gif" alt="Tea Cup" className="w-full md:w-32 md:h-32 object-cover rounded-md" data-id="element-110" />
                  <div data-id="element-111">
                    <h4 className="font-bold text-gray-900 mb-2 md:text-[21px]" data-id="element-112">
                      The best part – it couldn't be any easier to enjoy this
                      rich, complex, and beneficial mix.
                    </h4>
                    <p className="text-sm md:text-[21px] text-gray-600 leading-8" data-id="element-113">
                      All you need to do is boil some water, steep it for a few
                      minutes, et voila. You're ready to boost weight loss, and
                      your well-being.
                    </p>
                  </div>
                </div>

                <div className="mt-6 flex justify-center" data-id="element-114">
                  <CTAButton data-id="element-115">CHECK AVAILABILITY</CTAButton>
                </div>
              </div>

              {/* Testimonials Section */}
              <div className="mb-12" data-id="element-116">
                <h3 className="text-2xl font-bold text-[#10b981] mb-6" data-id="element-117">
                  Join Thousands Of Happy Customers
                </h3>
                <p className="text-gray-700 mb-8 md:text-[21px]" data-id="element-118">
                  People swear by Lulutox, and we think you will too. Here's
                  what keeps customers coming back:
                </p>

                <div className="space-y-4" data-id="element-119">
                  <TestimonialCard name="Kelly" age={46} text="And I am back to my size! After 2 pregnancies I gained some weight. But with Lulutox detox tea it went down from size 9 to size 4! I am so happy now and feeling great. Thank You!" imageSrc="https://cdn.magicpatterns.com/uploads/3gQDJUxigx3277oqLyWVCt/reader-pic1.jpg" data-id="element-120" />
                  <TestimonialCard name="Amanda" age={39} text="I LOVE it! It literally stops all bloating problems! 😋 Taste is great and all my friends are now frequent buyers." imageSrc="https://cdn.magicpatterns.com/uploads/4ZBpLEuQqv7NwoJFAng9YZ/reader-pic2.jpg" data-id="element-121" />
                  <TestimonialCard name="Sarah" age={52} text="I have tried other detox tea brands and they have never worked as well as this one does. It's been A little over a year since discovering it & I still use this. Best decision ever! LOVE IT" imageSrc="https://cdn.magicpatterns.com/uploads/1vw9xydARXBhWDh4zgAQWP/reader-pic3.jpg" data-id="element-122" />
                  <TestimonialCard name="Tyra" age={42} text="I see most people use this just one time to clear they system! But I use this as a weight loss product! I drink a tea packet everyday along with me healthy eating and I am shedding pounds! I feel like a beautiful butterfly" imageSrc="https://cdn.magicpatterns.com/uploads/efyz4zDjbAz6kxBSFfZcSh/reader-pic4.jpg" data-id="element-123" />
                </div>
              </div>

              {/* Final Offer Section */}
              <div className="bg-pink-50 rounded-xl p-8 text-center border-2 border-pink-100" data-id="element-124">
                <h3 className="text-xl md:text-[21px] font-bold text-gray-900 mb-4 leading-9" data-id="element-125">
                  [Claim my 70% OFF]:{' '}
                  <span className="font-normal" data-id="element-126">
                    You can only get Lulutox from their{' '}
                    <a href="https://trk.healthproductsguru.com/click" className="text-blue-600 underline" data-id="element-127">
                      official website
                    </a>
                    . There are many imitators, so you must{' '}
                    <span className="font-bold" data-id="element-128">
                      be careful. Claim your 70% discount
                    </span>{' '}
                    from the official{' '}
                    <a href="https://trk.healthproductsguru.com/click" className="text-blue-600 underline" data-id="element-129">
                      Lulutox website
                    </a>{' '}
                    while there's still time.
                  </span>
                </h3>

                <div className="relative inline-block my-8" data-id="element-130">
                  <img src="https://cdn.magicpatterns.com/uploads/kLJaLKVDzSBrSJs3uYnd1w/product6small.png" alt="Lulutox Product" className="w-64 mx-auto rounded-lg shadow-xl" data-id="element-131" />
                </div>

                <div className="flex justify-center mb-4" data-id="element-132">
                  <CTAButton size="lg" className="bg-[#10b981] hover:bg-[#059669] text-white w-full md:w-auto" data-id="element-133">
                    GET LULUTOX 70% OFF NOW
                  </CTAButton>
                </div>

                <p className="text-xs md:text-[21px] text-gray-500 font-medium" data-id="element-134">
                  Sell-out risk:{' '}
                  <span className="text-red-500 font-bold" data-id="element-135">High</span>
                </p>
              </div>
            </main>
          </div>

          {/* Sidebar Column (Desktop) */}
          <aside className="hidden lg:block lg:col-span-4 space-y-2" data-id="element-136">
            <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-2" data-id="element-137">
              <h3 className="text-xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-1" data-id="element-138">
                Customer reviews
              </h3>

              <div className="space-y-2" data-id="element-139">
                <CustomerReview name="Sarah Swanson" text="I kept seeing ads for Lulutox tea, so when I saw discount and 30-day money back guarantee so I decided to try! After about a week of drinking it 2 times a day (I know it says 1 time but I really love the taste :D ), I can gladly say that I feel AMAZING!!! no more bloating and my skin improved!" data-id="element-140" />
                <CustomerReview name="Kelly Peterson" text="I LOVE it! Such an easy way to start my weightloss journey. The order came quickly and it's so delicious 😋 I'm so looking forward to seeing my change. Thank you !" data-id="element-141" />
              </div>
            </div>

            {/* Product Image + CTA - Sticky Section */}
            <div className="sticky top-4 bg-white border border-gray-200 rounded-lg shadow-sm p-2" data-id="element-142">
              {/* Product Image Section */}
              <div className="text-center" data-id="element-143">
                <img src="https://cdn.magicpatterns.com/uploads/m9okwSLynPEmfdLfKyBpko/product1small.png" alt="Lulutox Detox Tea Product" className="w-full max-w-[280px] mx-auto mb-2" data-id="element-144" />
                <a href="https://trk.healthproductsguru.com/click" className="text-blue-600 hover:text-blue-700 font-bold text-xl underline inline-block" data-id="element-145">
                  Natural Energizing Detox Tea
                </a>
              </div>

              <div className="mt-2 pt-2 border-t border-gray-200" data-id="element-146">
                <CTAButton size="lg" fullWidth data-id="element-147">
                  Check Availability
                </CTAButton>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200 py-12 px-4 mt-12" data-id="element-148">
        <div className="max-w-4xl mx-auto text-center text-slate-500 text-xs space-y-4" data-id="element-149">
          <div className="flex justify-center gap-6 mb-6 font-medium" data-id="element-150">
            <a href="https://legal.lulutox.com/terms?utm_auid=1ac41890-ef4b-11f0-aa8c-dd9ad050962b&utm_campaign=40&utm_source=aff&domain1=www.dealsforyoudaily.com&ev_oid=10&network_id=69&s5=&sub1=41ed4a6b203f48cf83740b076e702c72&sub2=21260&sub3=7925&sub4=&uid=64" className="hover:text-slate-800" data-id="element-151">
              TERMS AND CONDITIONS
            </a>
            <a href="https://legal.lulutox.com/privacy?utm_auid=1ac41890-ef4b-11f0-aa8c-dd9ad050962b&utm_campaign=40&utm_source=aff&domain1=www.dealsforyoudaily.com&ev_oid=10&network_id=69&s5=&sub1=41ed4a6b203f48cf83740b076e702c72&sub2=21260&sub3=7925&sub4=&uid=64" className="hover:text-slate-800" data-id="element-152">
              PRIVACY POLICY
            </a>
            <a href="https://www.lulutox-official.com/privacy/?utm_auid=1ac41890-ef4b-11f0-aa8c-dd9ad050962b&utm_campaign=40&utm_source=aff&domain1=www.dealsforyoudaily.com&ev_oid=10&network_id=69&s5=&sub1=41ed4a6b203f48cf83740b076e702c72&sub2=21260&sub3=7925&sub4=&uid=64" className="hover:text-slate-800" data-id="element-153">
              COOKIE POLICY
            </a>
            <a href="https://www.lulutox-official.com/contact/?utm_auid=1ac41890-ef4b-11f0-aa8c-dd9ad050962b&utm_campaign=40&utm_source=aff&domain1=www.dealsforyoudaily.com&ev_oid=10&network_id=69&s5=&sub1=41ed4a6b203f48cf83740b076e702c72&sub2=21260&sub3=7925&sub4=&uid=64" className="hover:text-slate-800" data-id="element-154">
              CONTACT US
            </a>
          </div>
          <p data-id="element-155">COPYRIGHT, Lulutox</p>
          <p className="max-w-2xl mx-auto leading-relaxed opacity-70" data-id="element-156">
            THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
            CONSUMER PROTECTION UPDATE
            <br data-id="element-157" />
            <br data-id="element-158" />
            MARKETING DISCLOSURE: This website promotes certain products. As
            such you should know that the owner has a monetary connection to the
            product and services advertised on the site. Rest assured, we only
            state what we believe in.
            <br data-id="element-159" />
            <br data-id="element-160" />
            ADVERTISING DISCLOSURE: This website and the products & services
            referred to on the site are advertising marketplaces. This website
            is an advertisement and not a news publication. Photographs of
            persons used on this site are the brand's material or the actual
            product users.
            <br data-id="element-161" />
            <br data-id="element-162" />
            HEALTH DISCLAIMER: Lulutox is not a prescription drug or any other
            controlled substance. Lulutox products are not intended to diagnose,
            treat, cure, or prevent any specific disease or condition, but
            rather to provide a complimentary supplement to the professionally
            assigned treatments. Exercise and proper diet are necessary to
            achieve and maintain any form of weight loss. Individual results may
            vary. If you are pregnant, nursing, or have a medical condition,
            consult a physician before using this supplement. Statements on this
            website have not been evaluated by the Food and Drug Administration.
          </p>
        </div>
      </footer>
    </div>;
}